import { Component, OnInit, Input, Inject, EventEmitter, Output} from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl, ReactiveFormsModule } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { DatePipe } from '@angular/common';
import { NotificationsService } from 'angular2-notifications';
import * as _ from 'lodash';
import { NgxSpinnerService } from 'ngx-spinner';

import { ModalService, DriverService, CarrierService,
  ServerService, CommonService, RecordkeeperService } from './../../services/index';

import { Driver } from './../../models/driver';

import {IMyOptions} from 'mydatepicker';

import { Carrier, CarrierDriver, CarrierFleetDriver, CarrierFleet} from './../../models/carrier';
import { RecordKeeperDriver } from './../../models/recordkeeper';
import { ServerDriver } from './../../models/server';
import { Status, State, LicenceState } from './../../models/common.enum';

import { DatabaseComponent } from './../../admin/driver/database/database.component';
import * as moment from 'moment';
import { RecordKeeper } from 'src/app/models';
import { AuthHelper } from '../auth-helper';

@Component({
  selector: 'app-driver-form',
  templateUrl: './driverform.component.html',
  styleUrls: ['./driverform.component.css']
})
export class DriverFormComponent implements OnInit {
  @Input() public modalId: string;
  @Input() public isModal: boolean;
  @Output() reload: EventEmitter<any> = new EventEmitter();
  TitleDriver: string;
  DriverEdit: boolean;
  showCarriers: boolean;
  driver: Driver;
  form: FormGroup;
  displayForm: boolean;
  public isAdmin = false;

  submitted: boolean;
  isLoading: boolean;

  today = new Date();
  dateOfBirthOptions: IMyOptions = {
        dateFormat: 'dd/mm/yyyy',
        disableSince: {year: this.today.getFullYear(), month: this.today.getMonth() + 1, day: this.today.getDate() + 1}
  };
  licenceDateOptions: IMyOptions = {
    dateFormat: 'dd/mm/yyyy',
    disableUntil: {year: this.today.getFullYear(), month: this.today.getMonth() + 1, day: this.today.getDate() + 1}
  };

  carriers: Carrier[] = [];
  carrierAll: Carrier[] = [];
  carrierDrivers: CarrierDriver[] = new Array<any>();
  carrierFleetDrivers: CarrierFleetDriver[] = new Array<any>();
  recordKeeperDrivers: RecordKeeperDriver[] = new Array<any>();
  serverDrivers: ServerDriver[] = new Array<any>();
  states: string[] = Object.keys(State).filter(k => typeof State[k as any] === 'number');
  licencestates: string[] = Object.keys(LicenceState).filter(k => typeof LicenceState[k as any] === 'number');
  recordKeepers: RecordKeeper[] = [];

 constructor(
    private formBuilder: FormBuilder,
    private modalService: ModalService,
    private driverService: DriverService,
    private notificationService: NotificationsService,
    private carrierService: CarrierService,
    private recordKeeperService: RecordkeeperService,
    private serverService: ServerService,
    private router: Router,
    private spinner: NgxSpinnerService,
    ) {
      this.isAdmin = AuthHelper.IsAdmin();
      this.loadForm();
    }

    loadForm() {
      const emailRegex = /^([A-Za-z0-9_\-\.\''])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,63})$/
      this.form = this.formBuilder.group({
        id: [''],
        firstName: ['', [Validators.required]],
        lastName: ['', [Validators.required]],
        email: new FormControl('', {validators: [Validators.required, Validators.pattern(emailRegex)], updateOn: 'blur'}),
        phone: ['', [Validators.required]],
        address1: ['', [Validators.required]],
        address2: [''],
        city: ['', [Validators.required]],
        zipCode: ['', [Validators.required]],
        state: ['', [Validators.required]],
        baseState: ['', [Validators.required]],
        licenceNumber: ['', [Validators.required]],
        licenceType: ['', [Validators.required]],
        licenceExpiry: ['', [Validators.required]],
        licenceState: ['', [Validators.required]],
        dateOfBirth: ['', [Validators.required]],
        udi: [''],
        rkSearch: ['']
      });
    }

  ngOnInit() {

  }

  onLoad() {
    // by default, the driver is added
    this.TitleDriver = 'Add new driver';

    this.DriverEdit = false;

    this.showCarriers = this.isModal || this.DriverEdit ? true : false;

    this.displayForm = false;

    if (!this.isAdmin && !this.isModal) {
      this.displayForm = true;
    }

    if (this.isModal) {
      this.carrierService.getCarriers().subscribe(
      carriers => {
        this.carriers = carriers;
      });
    }

    if (!this.isModal && !this.DriverEdit) {
      this.SetNewValues();
    }
  }

  SetNewValues(): void {
    this.form.patchValue({
        id: 0,
      });
  }

  showForm() {
    this.displayForm = true;
  }

  closeModal() {
    // reset the title to default
    this.TitleDriver = 'Add new driver';

    this.displayForm = false;
    this.submitted = false;
    this.loadForm();
    this.ResetDriver();

    if (this.isModal) {
        this.modalService.close(this.modalId);
      } else if (!this.isAdmin)  {
        this.router.navigate(['/driver/home']);
      } else {
        this.router.navigate(['/login']);
    }
    this.driver = null;
}

  doRemove(item) {
    const index = this.carrierDrivers.indexOf(item);
    this.carrierDrivers.splice(index, 1);
  }

  doRemoveRecordKeeper(recordKeeperDriver) {
    const index = this.recordKeeperDrivers.indexOf(recordKeeperDriver);
    this.recordKeeperDrivers.splice(index, 1);
  }

  doAdd(item) {
    const formModel = this.form.value;
    const duplicate = _.find(this.carrierDrivers, { 'CarrierId': item.Id, 'DriverId': formModel.id });
    if (duplicate === undefined) {
      const carrierDriver: CarrierDriver = {
        Id: 0,
        CarrierId: item.Id,
        DriverId: (formModel.id === '' ? 0 : formModel.id),
        Name: item.Name,
        IsApproved: this.isAdmin,
        Carrier: null
      };
      this.carrierDrivers.push(carrierDriver);
    }
  }

  selectCarrierDriverItem(item) {
    this.doRemove(item);
  }

  getRecordKeeper(id) {
    return this.recordKeepers.find(rk => rk.Id == id);
  }

  onRKSearchChange(searchString) {
    var self = this;
    this.recordKeeperService.searchRecordKeepers(searchString)
    .subscribe(
      result => {
        this.recordKeepers = result.filter(recordKeeper => { return !self.recordKeeperDrivers.find(rkd => rkd.RecordKeeperId == recordKeeper.Id) });
      }
    ,
    error => {
      this.notificationService.error('Error', error);
    });

  }

  onSelectRecordKeeper(recordKeeper) {

      const formModel = this.form.value;
      const recordKeeperDriver: RecordKeeperDriver = {
        Id: 0,
        RecordKeeperId: recordKeeper.Id,
        DriverId: this.driver ? this.driver.Id : -1,
        Driver: null,
        RecordKeeper: recordKeeper
      };

      const duplicate = _.find(this.recordKeeperDrivers, { 'RecordKeeperId': recordKeeper.Id });
      if (duplicate === undefined) {
        this.recordKeeperDrivers.push(recordKeeperDriver);
        this.recordKeeperDrivers = _.orderBy(this.recordKeeperDrivers, [ rkd => rkd.RecordKeeper.FullName.toLowerCase()], ['asc']);
        const index = this.recordKeepers.indexOf(recordKeeper);
        this.recordKeepers.splice(index, 1);
      }
  }

  ResetDriver() {
    this.carrierDrivers = new Array<any>();
    this.carrierFleetDrivers = [];
    this.recordKeeperDrivers = new Array<any>();
    this.serverDrivers = [];
  }

  AssignDriver(driver: Driver): void {

    this.driver = driver;

    this.TitleDriver = 'Edit ' + driver.FullName;
    this.DriverEdit = true;

    this.showCarriers = true;

    this.form.setValue({
      id: driver.Id,
      firstName: driver.FirstName,
      lastName: driver.LastName,
      email: driver.Email,
      phone: driver.PhoneNumber,
      address1: driver.Address1,
      address2: driver.Address2,
      city: driver.City,
      zipCode: driver.ZipCode,
      state: driver.State,
      baseState: driver.BaseState,
      licenceNumber: driver.LicenceNumber,
      licenceType: driver.LicenceType,
      licenceExpiry: CommonService.ConvertToDateObject(moment(driver.LicenceExpiry), true),
      dateOfBirth: CommonService.ConvertToDateObject(moment(driver.DateOfBirth), true),
      licenceState: driver.LicenceState,
      udi: driver.Identifier,
      rkSearch: ''
    });
    this.carrierDrivers = new Array<any>();
    driver.CarrierDrivers.forEach(item => {
      const carrierDriver: CarrierDriver = {
        Id: 0,
        CarrierId: item.CarrierId,
        DriverId: item.DriverId,
        Name: item.Name,
        IsApproved: item.IsApproved,
        Carrier: null
      };
      this.carrierDrivers.push(carrierDriver);
    });

    this.carrierFleetDrivers = [];
    driver.CarrierFleetDrivers.forEach(item => {
      const carrierFleetDriver: CarrierFleetDriver = {
        Id: item.Id,
        CarrierFleetId: item.CarrierFleetId,
        ExternalDriverId: item.ExternalDriverId,
        DriverId: item.DriverId,
        DisplayName: item.DisplayName
      }
      this.carrierFleetDrivers.push(carrierFleetDriver);
    });

    this.recordKeeperDrivers = [];
    driver.RecordKeeperDrivers.forEach(item => {
      const recordKeeperDriver: RecordKeeperDriver = {
        Id: item.Id,
        RecordKeeperId: item.RecordKeeperId,
        RecordKeeper: item.RecordKeeper,
        DriverId: item.DriverId,
        Driver: item.Driver
      }
      this.recordKeeperDrivers.push(recordKeeperDriver);
    });

    this.displayForm = true;
  }

  enable() {
    this.isLoading = true;

    if (confirm("Please confirm you would like to enable driver " + this.driver.FullName))
    {
      this.driverService.enableDriver(this.driver.Id).subscribe(data => {

        this.notificationService.success('Success', "Driver enabled");
        this.reload.emit(true);
        this.closeModal();
        this.isLoading = false;
      },
      error => {
        this.notificationService.error('Error', error._body);
        this.isLoading = false;
      });
    }
  }

  OnSave(isValid: boolean) {
    this.submitted = true;
    this.isLoading = true;
    const formModel = this.form.value;
    if (!isValid) {
      // this.notificationService.error('Failure', 'Please check the fields and try again' );
      this.isLoading = false;
      return;
    }

    let result;
    const datePipe = new DatePipe('en-US');

    let allowed = this.isModal ? 'true' : 'false';

    let driver;

    if (this.DriverEdit) {
      driver = this.driver;
    } else {
      driver = new Driver();
    }

    driver.Id = formModel.id;

    if (this.DriverEdit) {
      allowed = 'true';
    }

    driver.FirstName = formModel.firstName,
    driver.LastName = formModel.lastName,
    driver.Email = formModel.email,
    driver.PhoneNumber = formModel.phone;
    driver.Address1 = formModel.address1,
    driver.Address2 = formModel.address2,
    driver.City = formModel.city,
    driver.ZipCode = formModel.zipCode,
    driver.State = formModel.state,
    driver.LicenceNumber = formModel.licenceNumber;
    driver.LicenceType = formModel.licenceType;
    driver.LicenceExpiry = CommonService.dateISOFormatted(CommonService.ConvertToDate(formModel.licenceExpiry, true));
    driver.LicenceState = formModel.licenceState;
    driver.BaseState = formModel.baseState;
    driver.Status = 1;
    driver.CarrierDrivers = this.carrierDrivers;
    driver.CarrierFleetDrivers = this.carrierFleetDrivers;
    driver.DateOfBirth = CommonService.dateISOFormatted(CommonService.ConvertToDate(formModel.dateOfBirth, true));
    driver.RecordKeeperDrivers = this.recordKeeperDrivers;

    if (driver.Id) {
      result = this.driverService.updateDriver(driver.Id, driver);
    } else {
      driver.Id = 0;
      result = this.driverService.addDriver(driver);
    }

    result.subscribe(data => {
      let message: string;

      message  = !this.DriverEdit ? 'Driver successfully created, they will receive a confirmation email' :
      'Your changes have been saved successfully';

      this.notificationService.success('Success', message);
      this.reload.emit(true);
      this.closeModal();
      this.isLoading = false;
    },
      error => {
        //this.notificationService.error('Error', error._body);
        this.isLoading = false;
      });
  };
}
